import { CircleCloseIcon } from 'assets/icons';
import { Button, CustomModal } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { joinItemArray } from 'containers/product-catalog/items/utils';
import { FC } from 'react';
import { VoidFn } from 'types/baseTypes';

interface EstimateCreationConfirmationPopupProps {
  isSaveItemLoading: boolean;
  onContinue: VoidFn;
  closeSaveConfirmation: VoidFn;
  estimateRefNumber: string;
  conflictingItems: Array<string>;
}

const EstimateCreationConfirmationPopup: FC<EstimateCreationConfirmationPopupProps> = ({
  isSaveItemLoading,
  onContinue,
  closeSaveConfirmation,
  estimateRefNumber,
  conflictingItems
}) => {
  return (
    <CustomModal open={true} width="md:w-[384px]">
      <div className="relative flex w-full flex-col items-center p-10">
        <div className="absolute top-2 right-2">
          <CircleCloseIcon onClick={closeSaveConfirmation} className="shrink-0 cursor-pointer" />
        </div>
        <div className={'mb-4 text-center text-17px font-semibold text-heading'}>
          Save estimate using duplicate <br /> estimate reference number?
        </div>
        <div className={'mb-2.5 text-center text-sbase font-normal text-primaryText'}>
          Estimate reference number '{estimateRefNumber}' already exists in {joinItemArray(conflictingItems, 2, false)}
        </div>
        <div className={'mb-4 text-center text-sbase font-normal text-primaryText'}>
          Are you sure you want to save this estimate using duplicate estimate reference number?
        </div>
        <Button
          id="create-estimate-confirmation"
          className="mb-[18px] h-[38px] w-full bg-primaryBtn font-lato text-sbase font-semibold text-primary"
          onClick={onContinue}
          isLoading={isSaveItemLoading}>
          Yes, continue
        </Button>
        <Button
          id="create-estimate-cancel"
          className="h-[38px] w-full border-primaryBtn
          font-lato text-sbase font-semibold text-secondaryBtnText hover:bg-secondaryBtn"
          onClick={closeSaveConfirmation}
          type={ButtonType.SECONDARY}>
          Cancel
        </Button>
      </div>
    </CustomModal>
  );
};

export default EstimateCreationConfirmationPopup;
